import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

export const ErpIframePageLayout = () => {
  return (
    <Box
      id="erp-page"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        p: 5,
      }}
    >
      <Outlet />
    </Box>
  );
};
